/*
 *   File : uploaded-preview.js
 *   Author : https://evoqins.com
 *   Description : Uploaded preview modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';

//Custom components
import { Icon } from '../Icon';
import { Loader } from '../Others';

const UploadedPreview = (props) => {
    const [csvData, setCsvData] = useState([]);

    const _handleCloseModal = () => {
        var button = document.getElementById("uploaded-preview-modal-close");
        button.click();
        props.handleClose();
    };

    useEffect(() => {
        Papa.parse(props.file, {
            download: true,
            header: true,
            complete: function (results) {
                setCsvData(results.data);
            }
        });
    }, []);

    return (
        <div className="modal fade"
            id="uploaded-preview-modal"
            data-bs-backdrop="false"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="PreviewModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 padding-32px-bottom modal-lg e-uploaded-preview-modal`}>
                <span id='uploaded-preview-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={`modal-content border-radius-28 border-0`}>
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-2">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Uploaded file
                        </h6>
                        <Icon icon='close' size="1.125rem" className="d-flex cursor-pointer" onClick={_handleCloseModal} />
                    </div>

                    <div className="modal-body px-0 pt-3">
                        <div className='padding-32px-lr text-center pb-3' style={{ maxHeight: "600px", overflow: "auto" }}>
                            {csvData.length > 0 ? (
                                <table className='table table-bordered'>
                                    <thead>
                                        <tr>
                                            {Object.keys(csvData[0]).map((key, i) => (
                                                <th key={i}>{key}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {csvData.map((row, i) => (
                                            <tr key={i}>
                                                {Object.values(row).map((val, j) => (
                                                    <td key={j}>{val}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <Loader className="py-5" />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadedPreview;
